import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AuthModal from '../components/AuthModal';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Sidebar from '../components/Sidebar';
import discord from '../assets/discord.png';
import twitter from '../assets/twitter.png';
import group41Icon from '../assets/group41.png';
import timeIcon from '../assets/time.png';
import coins_1 from '../assets/coins 1.png';
import likeIcon from '../assets/Like_icon.png';
import unLikeIconImage from '../assets/unLike_icon.png';
// Коллекция 1 - изображения
import col1_img1 from '../assets/col1_img1.jpg';
import col1_img2 from '../assets/col1_img2.jpg';
import col1_img3 from '../assets/col1_img3.jpg';
import col1_img4 from '../assets/col1_img4.jpg';
import col1_img5 from '../assets/col1_img5.jpg';
import col1_img6 from '../assets/col1_img6.jpg';
import col1_img7 from '../assets/col1_img7.jpg';
import col1_img8 from '../assets/col1_img8.jpg';
import col1_background from '../assets/col1_background.jpg';
// Коллекция 2 - изображения
import col2_img1 from '../assets/col2_img1.jpg';
import col2_img2 from '../assets/col2_img2.jpg';
import col2_img3 from '../assets/col2_img3.jpg';
import col2_img4 from '../assets/col2_img4.jpg';
import col2_img5 from '../assets/col2_img5.jpg';
import col2_img6 from '../assets/col2_img6.jpg';
import col2_img7 from '../assets/col2_img7.jpg';
import col2_img8 from '../assets/col2_img8.jpg';
import col2_img9 from '../assets/col2_img9.jpg';
import col2_background from '../assets/col2_background.jpg';
// Коллекция 3 - изображения
import col3_img1 from '../assets/col3_img1.jpg';
import col3_img2 from '../assets/col3_img2.jpg';
import col3_img3 from '../assets/col3_img3.jpg';
import col3_img4 from '../assets/col3_img4.jpg';
import col3_img5 from '../assets/col3_img5.jpg';
import col3_img6 from '../assets/col3_img6.jpg';
import col3_background from '../assets/col3_background.jpg';
// Коллекция 4 - изображения
import col4_img1 from '../assets/col4_img1.jpg';
import col4_img2 from '../assets/col4_img2.jpg';
import col4_img3 from '../assets/col4_img3.jpg';
import col4_img4 from '../assets/col4_img4.jpg';
import col4_img5 from '../assets/col4_img5.jpg';
import col4_img6 from '../assets/col4_img6.jpg';
import col4_img7 from '../assets/col4_img7.jpg';
import col4_img8 from '../assets/col4_img8.jpg';
import col4_background from '../assets/col4_background.jpg';
// Коллекция 5 - изображения
import col5_img1 from '../assets/col5_img1.jpg';
import col5_img2 from '../assets/col5_img2.jpg';
import col5_img3 from '../assets/col5_img3.jpg';
import col5_img4 from '../assets/col5_img4.jpg';
import col5_img5 from '../assets/col5_img5.jpg';
import col5_background from '../assets/col5_background.jpg';
// Коллекция 6 - изображения
import col6_img1 from '../assets/col6_img1.jpg';
import col6_img2 from '../assets/col6_img2.jpg';
import col6_img3 from '../assets/col6_img3.jpg';
import col6_img4 from '../assets/col6_img4.jpg';
import col6_img5 from '../assets/col6_img5.jpg';
import col6_img6 from '../assets/col6_img6.jpg';
import col6_background from '../assets/col6_background.jpg';

export default function CollectionDetailPage() {
  const [hoveredCardIndex, setHoveredCardIndex] = useState(null);
  const [collectionData, setCollectionData] = useState(null);
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [waitingListLoading, setWaitingListLoading] = useState(false);
  const [waitingListFeedback, setWaitingListFeedback] = useState(null);
  const [animatingLikeIndex, setAnimatingLikeIndex] = useState(null);
  const [animatingCollectionLike, setAnimatingCollectionLike] = useState(false);
  const { user, addToWaitingList, removeFromWaitingList, addToFavorites, removeFromFavorites, addToCollections, removeFromCollections } = useAuth();
  const { slug } = useParams();
  const navigate = useNavigate();

  // Функция для загрузки данных коллекции из БД
  const fetchCollectionData = async (collectionSlug = slug) => {
    if (!collectionSlug) return;
    
    try {
      const response = await fetch(`/api/collections/${collectionSlug}`);
      if (response.ok) {
        const data = await response.json();
        setCollectionData(data.collection);
        console.log('✅ Данные коллекции обновлены. Followers:', data.collection?.stats?.followers);
      } else {
        console.error('Failed to fetch collection data');
      }
    } catch (error) {
      console.error('Error fetching collection data:', error);
    }
  };

  // Загрузка данных коллекции из БД
  useEffect(() => {
    if (slug) {
      fetchCollectionData();
    }
  }, [slug]);


  // Данные коллекций с изображениями
  const collectionsData = {
    'cyberpank': {
      images: [col1_img1, col1_img2, col1_img3, col1_img4, col1_img5, col1_img6, col1_img7, col1_img8],
      background: col1_background,
      title: 'Cyberpank'
    },
    'myth-cats': {
      images: [col2_img1, col2_img2, col2_img3, col2_img4, col2_img5, col2_img6, col2_img7, col2_img8, col2_img9],
      background: col2_background,
      title: 'Myth Cats'
    },
    'future-illusion': {
      images: [col3_img1, col3_img2, col3_img3, col3_img4, col3_img5, col3_img6],
      background: col3_background,
      title: 'Future Illusion'
    },
    'spirits-above': {
      images: [col4_img1, col4_img2, col4_img3, col4_img4, col4_img5, col4_img6, col4_img7, col4_img8],
      background: col4_background,
      title: 'Spirits Above'
    },
    'wonder': {
      images: [col5_img1, col5_img2, col5_img3, col5_img4, col5_img5],
      background: col5_background,
      title: 'Wonder'
    },
    'energy-near-you': {
      images: [col6_img1, col6_img2, col6_img3, col6_img4, col6_img5, col6_img6],
      background: col6_background,
      title: 'Energy Near You'
    }
  };

  // Тексты для секции About для каждой коллекции
  const aboutTexts = {
    'myth-cats': `Collection of digital depictions of mythical cats inspired by global symbolism. Each art piece incorporates motifs from Maneki-neko, Egypt's Bastet, Norse legends of forest cats, and other cultural myths.

The characters reflect artistic styles from different eras and traditions, preserving an atmosphere of mystery and expressiveness. The collection blends art and mythology, offering a modern interpretation of the mythical cat.`,
    'cyberpank': `The Cyberpunk Girls collection of Nine, tells the story of a neon-drenched future city, where skyscrapers fade into holographic haze and streets glow with digital reflections.

Each girl represents a hidden facet of the metropolis — from the shining heights of corporate towers to shadowy underground tunnels.

Their appearances combine neon colors, digital patterns, implants, and stylized accessories, reflecting street energy, technology, rebellion, or industrial aesthetics. Together, the nine images form a cohesive narrative of a city where style is a language, technology merges with identity, and neon light reveals personality, capturing the essence of a vibrant, futuristic urban world.`,
    'future-illusion': `There are cities where the line between human and machine is almost erased, where neural networks control streams of consciousness, and others where art, music, and light shows create a language of street emotions.

Some districts have preserved the industrial chaos of the past, turning abandoned factories and ruins into spaces for rebellious culture. Others shine with a harmony of technology and energy, where light, electricity, and ecological systems intertwine, creating the feeling of a living city.

Together, the six cities form an entire universe, where technology reflects the character of the streets, technology becomes part of life, and each district tells its own story of the future, full of contrasts, mysteries, and light.`,
    'spirits-above': `Eight teenagers became the victims of ancient cursed spirits. These entities settled behind their backs, quietly and unnoticed, until they completely took over their will. The teenagers no longer belong to themselves: thoughts, desires, and fears dissolve, giving way to the darkness that slowly consumes their souls.

Now they are nothing but shells, carriers of another's will. Shadows behind them whisper, command, and manipulate. Their eyes sometimes reflect remnants of humanity, but inside, a foreign entity reigns, feeding on fear.

Reality has turned into a nightmare with no escape. Every touch, every glance is a trap. The spirits have fully dominated them, turning them into instruments of their dark plans.`,
    'wonder': `Five glowing streams suddenly appeared above the city, hovering high in the air. No one knew where they had come from, but every resident felt their presence in their own way—sometimes as warmth, sometimes as a strange tension.

At first, people were afraid. Ordinary tasks seemed insignificant in the face of this mystery. Gradually, some began to notice that the energies were changing the city: streets seemed brighter, old buildings appeared alive, and people began to see what had previously been hidden.

The city became a magnet for the curious: scientists, researchers, and ordinary residents all tried to understand how these forces influenced their lives. Some tried to control the energies, while others simply lived in harmony with them.

The city was no longer just a place on a map—it had become a living, breathing organism, with its residents as part of its heartbeat.`,
    'energy-near-you': `When the world was still formless and space was only beginning to flow, six spirits arose from the void. They did not appear together or in sequence—simply as part of the eternal current itself, each with its own secret, each with its own power. On the day when energy first trembled, space heard the whispers of these spirits for the first time, and from that moment their existence became part of a myth that no one could ever fully tell.

The spirits always exist nearby, yet each remains separate, and in the rare moments when their paths cross, wondrous phenomena arise—flashes seen only by those who can perceive the invisible, whispers heard only by those who can listen to the void. This story became an ancient parable of freedom, solitude, and the beauty of pure energy, which belongs to no one but the void itself.`
  };

  // Определяем текущую коллекцию по slug
  const currentCollection = collectionsData[slug] || collectionsData['cyberpank']; // fallback на первую коллекцию
  const nftImages = currentCollection.images;
  const backgroundImage = currentCollection.background;
  const effectiveSlug = (collectionData?.slug || slug || 'cyberpank')?.toString();
  const isInWaitingList = !!user?.waitingList?.includes(effectiveSlug);
  const waitingListButtonLabel = waitingListLoading ? 'Loading...' : 'Waiting List';
  const waitingListBackground = isInWaitingList ? 'rgba(66, 115, 51, 0.15)' : 'rgba(66, 115, 51, 0.15)';

  // Обработчик клика для Discord
  const handleDiscordClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const discordUrl = collectionData?.discord || user?.discord;
    console.log('Discord click:', discordUrl);
    if (discordUrl) {
      const url = discordUrl.startsWith('http') ? discordUrl : `https://${discordUrl}`;
      window.open(url, '_blank', 'noopener,noreferrer');
    } else {
      console.warn('Discord URL not found');
    }
  };

  // Обработчик клика для Twitter
  const handleTwitterClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const twitterUrl = collectionData?.twitter || user?.twitter;
    console.log('Twitter click:', twitterUrl);
    if (twitterUrl) {
      const url = twitterUrl.startsWith('http') ? twitterUrl : `https://${twitterUrl}`;
      window.open(url, '_blank', 'noopener,noreferrer');
    } else {
      console.warn('Twitter URL not found');
    }
  };

  const handleWaitingListToggle = async () => {
    if (!effectiveSlug) {
      console.warn('⚠️ Нет slug для добавления в waiting list');
      return;
    }

    if (!user) {
      setIsAuthModalOpen(true);
      return;
    }

    if (waitingListLoading) {
      return;
    }

    const action = isInWaitingList ? 'remove' : 'add';
    setWaitingListLoading(true);
    setWaitingListFeedback(null);

    const result = action === 'remove'
      ? await removeFromWaitingList(effectiveSlug)
      : await addToWaitingList(effectiveSlug);

    if (!result.success) {
      setWaitingListFeedback(result.message || 'Не удалось обновить Waiting List');
      if (result.requireAuth) {
        setIsAuthModalOpen(true);
      }
    } else {
      setWaitingListFeedback(
        action === 'remove'
          ? 'Коллекция удалена из Waiting List'
          : 'Коллекция добавлена в Waiting List'
      );
    }

    setWaitingListLoading(false);
  };

  const handleWaitingListKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleWaitingListToggle();
    }
  };

  // Проверка, лайкнута ли коллекция
  const isCollectionLiked = () => {
    if (!user || !Array.isArray(user.collections)) {
      return false;
    }
    return user.collections.some((col) => col.slug === effectiveSlug);
  };

  // Проверка, лайкнут ли NFTs
  const isNFTLiked = (nftIndex) => {
    if (!user || !Array.isArray(user.favorites)) {
      return false;
    }
    return user.favorites.some(
      (fav) =>
        fav.slug === effectiveSlug &&
        typeof fav.nftIndex === 'number' &&
        fav.nftIndex === nftIndex
    );
  };

  // Обработчик переключения лайка коллекции
  const handleCollectionLikeToggle = async (e) => {
    e.stopPropagation();
    
    if (!user) {
      setIsAuthModalOpen(true);
      return;
    }

    const currentlyLiked = isCollectionLiked();

    // Запускаем анимацию только при добавлении лайка
    if (!currentlyLiked) {
      setAnimatingCollectionLike(true);
      setTimeout(() => setAnimatingCollectionLike(false), 600);
    }

    if (!currentlyLiked) {
      const result = await addToCollections(effectiveSlug);
      if (!result.success) {
        console.error('Ошибка добавления коллекции в избранное:', result.message);
        if (result.requireAuth) {
          setIsAuthModalOpen(true);
        }
        setAnimatingCollectionLike(false);
      } else {
        // Обновляем данные коллекции, чтобы отобразить новое значение follower
        await fetchCollectionData(effectiveSlug);
      }
    } else {
      const result = await removeFromCollections(effectiveSlug);
      if (!result.success) {
        console.error('Ошибка удаления коллекции из избранного:', result.message);
      } else {
        // Обновляем данные коллекции, чтобы отобразить новое значение followers
        await fetchCollectionData(effectiveSlug);
      }
    }
  };

  // Обработчик переключения лайка
  const handleLikeToggle = async (e, nftIndex) => {
    e.stopPropagation(); // Предотвращаем переход на страницу NFT
    
    if (!user) {
      setIsAuthModalOpen(true);
      return;
    }

    const currentlyLiked = isNFTLiked(nftIndex);

    // Запускаем анимацию только при добавлении лайка
    if (!currentlyLiked) {
      setAnimatingLikeIndex(nftIndex);
      setTimeout(() => setAnimatingLikeIndex(null), 600); // Длительность анимации
    }

    if (!currentlyLiked) {
      const result = await addToFavorites(effectiveSlug, nftIndex);
      if (!result.success) {
        console.error('Ошибка добавления в favorites:', result.message);
        if (result.requireAuth) {
          setIsAuthModalOpen(true);
        }
        setAnimatingLikeIndex(null);
      }
    } else {
      const result = await removeFromFavorites(effectiveSlug, nftIndex);
      if (!result.success) {
        console.error('Ошибка удаления из favorites:', result.message);
      }
    }
  };

  return (
    <div className="h-screen bg-[#1E1E1E] text-white main-font flex flex-col overflow-hidden">
      <Header />

      <div className="flex flex-1 overflow-hidden">
        <Sidebar activePage="collection" />

        {/* Main Content */}
        <main className="flex-1 bg-[#1E1E1E] flex flex-col overflow-hidden">
          {/* Scrollable Content Area */}
          <div className="flex-1 overflow-y-auto overflow-x-hidden">
            <div className="relative" style={{ 
              width: 'clamp(840px, 86.6vw, 1670px)', 
              minHeight: 'clamp(540px, 56.25vw, 1080px)', 
              margin: '0' 
            }}>
              {/* Hero Section with Background */}
              <div 
                className="absolute"
                style={{
                  left: '0px',
                  top: '0px',
                  width: 'clamp(830px, 86.51vw, 1662px)',
                  height: 'clamp(270px, 28.13vw, 540px)',
                  overflow: 'hidden',
                  zIndex: 1
                }}
              >
                {/* Background Image */}
                <img 
                  src={backgroundImage}
                  alt="Collection Background"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    position: 'absolute',
                    top: 0,
                    left: 0
                  }}
                />
                
                {/* Gradient Overlay for bottom transition */}
                <div
                  style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    height: '50%',
                    background: 'linear-gradient(to bottom, transparent 0%, rgba(30, 30, 30, 0.8)50%, rgba(30, 30, 30, 0.8) 100%)',
                    pointerEvents: 'none',
                    zIndex: 1
                  }}
                />
                
                {/* "Collection" Label in top-left */}
                <div 
                  className="absolute"
                  style={{
                    left: 0,
                    top: 0,
                    width: 'clamp(55px, 5.73vw, 111px)',
                    height: 'clamp(17px, 1.77vw, 34px)',
                    backgroundColor: '#000000',
                    borderBottomRightRadius: 'clamp(5px, 0.57vw, 11px)',
                    zIndex: 2
                  }}
                >
                  <div 
                    style={{
                      position: 'absolute',
                      left: '50%',
                      top: '50%',
                      transform: 'translate(-50%, -50%)',
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: 'clamp(9px, 0.94vw, 18px)',
                      color: '#FFFFFF'
                    }}
                  >
                    Collection
                  </div>
                </div>

                {/* Waiting List Button - Top Right */}
                <div 
                  className="absolute"
                  role="button"
                  tabIndex={0}
                  aria-pressed={isInWaitingList}
                  aria-busy={waitingListLoading}
                  aria-label={isInWaitingList ? 'Remove from waiting list' : 'Add to waiting list'}
                  title={
                    waitingListFeedback ||
                    (isInWaitingList
                      ? 'Удалить коллекцию из Waiting List'
                      : 'Добавить коллекцию в Waiting List')
                  }
                  onClick={handleWaitingListToggle}
                  onKeyDown={handleWaitingListKeyDown}
                  style={{
                    right: 'clamp(10px, 1.04vw, 20px)',
                    top: 'clamp(21px, 2.19vw, 42px)',
                    display: 'flex',
                    gap: 0,
                    cursor: waitingListLoading ? 'wait' : 'pointer',
                    opacity: waitingListLoading ? 0.7 : 1,
                    pointerEvents: waitingListLoading ? 'none' : 'auto',
                    zIndex: 2
                  }}
                >
                  <img
                    src={timeIcon}
                    alt="Waiting list timer"
                    style={{
                      width: '30px',
                      height: '30px',
                      marginRight: 'clamp(6px, 0.63vw, 12px)',
                      transform: 'translateY(4px)'
                    }}
                  />
                  <div 
                    style={{
                      width: 'clamp(22px, 2.34vw, 45px)',
                      height: 'clamp(19px, 2.03vw, 39px)',
                      backgroundColor: isInWaitingList ? 'rgba(70, 125, 53, 0.8)' : 'rgba(66, 115, 51, 0.4)',
                      border: 'none',
                      borderTopLeftRadius: 'clamp(0.5px, 0.05vw, 1px)',
                      borderBottomLeftRadius: 'clamp(0.5px, 0.05vw, 1px)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      position: 'relative'
                    }}
                  >
                    {isInWaitingList ? (
                      <img 
                        src={group41Icon}
                        alt="Waiting list active"
                        style={{
                          width: 'clamp(10px, 1.09vw, 21px)',
                          height: 'clamp(10px, 1.09vw, 21px)',
                          opacity: waitingListLoading ? 0.6 : 1
                        }}
                      />
                    ) : (
                      <>
                        <div 
                          style={{
                            position: 'absolute',
                            left: '50%',
                            top: '50%',
                            transform: 'translate(-50%, -50%) rotate(0deg)',
                            width: 'clamp(2px, 0.21vw, 4px)',
                            height: 'clamp(9px, 0.94vw, 18px)',
                            backgroundColor: '#39e803',
                            borderRadius: 'clamp(2px, 0.21vw, 4px)',
                            opacity: waitingListLoading ? 0.6 : 1,
                            transition: 'opacity 0.2s ease'
                          }}
                        />
                        <div 
                          style={{
                            position: 'absolute',
                            left: '50%',
                            top: '50%',
                            transform: 'translate(-50%, -50%) rotate(90deg)',
                            width: 'clamp(2px, 0.21vw, 4px)',
                            height: 'clamp(9px, 0.94vw, 18px)',
                            backgroundColor: '#39e803',
                            borderRadius: 'clamp(2px, 0.21vw, 4px)',
                            opacity: waitingListLoading ? 0.6 : 1,
                            transition: 'opacity 0.2s ease'
                          }}
                        />
                      </>
                    )}
                  </div>
                  <div 
                    style={{
                      width: 'clamp(64px, 6.67vw, 128px)',
                      height: 'clamp(19px, 2.03vw, 39px)',
                      backgroundColor: waitingListBackground,
                      borderTopRightRadius: 'clamp(0.5px, 0.05vw, 1px)',
                      borderBottomRightRadius: 'clamp(0.5px, 0.05vw, 1px)',
                      display: 'flex',
                      alignItems: 'center',
                      paddingLeft: 'clamp(10px, 1.09vw, 21px)',
                      fontFamily: 'Keania One',
                      fontSize: 'clamp(8px, 0.83vw, 16px)',
                      color: 'rgba(255, 255, 255, 0.9)',
                      letterSpacing: '0.01em'
                    }}
                  >
                    {waitingListButtonLabel}
                  </div>
                </div>
                <span
                  aria-live="polite"
                  style={{
                    position: 'absolute',
                    width: '1px',
                    height: '1px',
                    padding: 0,
                    margin: '-1px',
                    overflow: 'hidden',
                    clip: 'rect(0, 0, 0, 0)',
                    whiteSpace: 'nowrap',
                    border: 0,
                    zIndex: 2
                  }}
                >
                  {waitingListFeedback || ''}
                </span>

                {/* About Section - Top Right */}
                <div 
                  className="absolute"
                  style={{
                    right: 'clamp(10px, 1.04vw, 20px)',
                    top: 'clamp(60px, 6.25vw, 120px)',
                    width: 'clamp(180px, 18.75vw, 360px)',
                    maxHeight: 'clamp(140px, 14.58vw, 280px)',
                    zIndex: 2,
                    backgroundColor: 'rgba(0, 0, 0, 0.4)',
                    border: 'clamp(0.5px, 0.05vw, 1px) solid rgba(143, 10, 10, 0.5)',
                    borderRadius: 'clamp(2px, 0.21vw, 4px)',
                    padding: 'clamp(12px, 1.25vw, 24px)',
                    paddingTop: 'clamp(10px, 1.04vw, 20px)',
                    paddingBottom: 'clamp(10px, 1.04vw, 20px)',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    boxSizing: 'border-box'
                  }}
                >
                  <div 
                    style={{
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: 'clamp(9px, 0.94vw, 18px)',
                      color: 'rgba(255, 255, 255, 0.9)',
                      marginBottom: 'clamp(10px, 1.04vw, 20px)',
                      paddingBottom: 'clamp(6px, 0.63vw, 12px)',
                      borderBottom: 'clamp(0.5px, 0.05vw, 1px) solid rgba(143, 10, 10, 0.3)'
                    }}
                  >
                    About
                  </div>
                  <div 
                    style={{
                      fontFamily: 'Keania One',
                      fontWeight: 400,
                      fontSize: 'clamp(8px, 0.83vw, 16px)',
                      color: 'rgba(255, 255, 255, 0.8)',
                      lineHeight: '1.5',
                      whiteSpace: 'pre-wrap',
                      wordWrap: 'break-word',
                      paddingRight: 'clamp(4px, 0.42vw, 8px)'
                    }}
                  >
                    {aboutTexts[effectiveSlug] || aboutTexts[slug] || 'There is a day when i thought and then it bacame a name of the collection, sounds like a situation when a thought is a name of the collection.'}
                  </div>
                </div>
              </div>

              {/* ProfileSelectionLine Section */}
              <div 
                className="absolute"
                style={{
                  left: 'clamp(0.5px, 0.05vw, 1px)',
                  top: 'clamp(192px, 20.05vw, 385px)',
                  width: 'clamp(830px, 86.46vw, 1660px)',
                  height: 'clamp(77px, 8.02vw, 155px)',
                  borderBottom: 'clamp(0.5px, 0.05vw, 1px) solid #8f0a0a',
                  position: 'relative',
                  background: 'transparent',
                  zIndex: 10
                }}
              >
                {/* Collection Info Group */}
                <div className="absolute" style={{ width: '100%', height: '100%' }}>
                  {/* Collection Avatar */}
                  <div 
                    className="absolute"
                    style={{
                      left: 'clamp(11px, 1.15vw, 23px)',
                      top: 'clamp(20px, 2.08vw, 40px)',
                      width: 'clamp(30px, 3.13vw, 60px)',
                      height: 'clamp(30px, 3.13vw, 60px)',
                      borderRadius: '50%',
                      overflow: 'hidden',
                      border: 'clamp(0.5px, 0.05vw, 1px) solid #8f0a0a'
                    }}
                  >
                    <img 
                      src={require('../assets/ellipse.png')}
                      alt="Collection Avatar"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />
                  </div>

                  {/* Vertical Divider */}
                  <div 
                    className="absolute"
                    style={{
                      left: 'clamp(48px, 5vw, 96px)',
                      top: 'clamp(20px, 2.08vw, 40px)',
                      width: 'clamp(0.5px, 0.05vw, 1px)',
                      height: 'clamp(40px, 4.17vw, 80px)',
                      backgroundColor: 'rgba(255, 0, 0, 0.3)'
                    }}
                  />

                  {/* Collection Name and Icons Container */}
                  <div 
                    className="absolute"
                    style={{
                      left: 'clamp(55px, 5.73vw, 110px)',
                      top: 'clamp(26px, 2.71vw, 52px)',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 'clamp(8px, 0.83vw, 16px)',
                      flexWrap: 'wrap'
                    }}
                  >
                    {/* Collection Name */}
                    <div 
                      style={{
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(9px, 0.94vw, 18px)',
                        color: 'rgba(255, 255, 255, 0.8)',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      {currentCollection.title || 'Law at the end of the day'}
                    </div>

                    {/* Like Icon */}
                    <div 
                      onClick={handleCollectionLikeToggle}
                      className="cursor-pointer hover:opacity-90 transition-opacity"
                      style={{
                        width: 'clamp(12px, 1.25vw, 24px)',
                        height: 'clamp(12px, 1.25vw, 24px)',
                        flexShrink: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <img 
                        src={isCollectionLiked() ? likeIcon : require('../assets/Like_icon2.png')}
                        alt={isCollectionLiked() ? 'Remove from favorites' : 'Add to favorites'}
                        style={{
                          width: '100%',
                          height: '100%',
                          transform: animatingCollectionLike ? 'scale(1.5)' : 'scale(1)',
                          transition: 'transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)'
                        }}
                      />
                    </div>

                    {/* Vertical Divider */}
                    <div 
                      style={{
                        width: 'clamp(0.5px, 0.05vw, 1px)',
                        height: 'clamp(9px, 0.94vw, 18px)',
                        backgroundColor: 'rgba(255, 255, 255, 0.3)',
                        flexShrink: 0
                      }}
                    />

                    {/* Social Icons */}
                    <div 
                      style={{
                        display: 'flex',
                        gap: 'clamp(6px, 0.63vw, 12px)',
                        alignItems: 'center',
                        flexShrink: 0
                      }}
                    >
                      <img 
                        src={require('../assets/copy-icon.png')}
                        alt="Copy"
                        style={{
                          width: 'clamp(7px, 0.73vw, 14px)',
                          height: 'clamp(7px, 0.73vw, 14px)',
                          opacity: 0.7,
                          cursor: 'pointer'
                        }}
                      />
                      <img 
                        src={discord}
                        alt="Discord"
                        onClick={handleDiscordClick}
                        style={{
                          width: 'clamp(8px, 0.83vw, 16px)',
                          height: 'clamp(8px, 0.83vw, 16px)',
                          opacity: 0.7,
                          cursor: 'pointer'
                        }}
                      />
                      <img 
                        src={twitter}
                        alt="Twitter"
                        onClick={handleTwitterClick}
                        style={{
                          width: 'clamp(7px, 0.73vw, 14px)',
                          height: 'clamp(7px, 0.73vw, 14px)',
                          opacity: 0.7,
                          cursor: 'pointer'
                        }}
                      />
                    </div>
                  </div>

                  {/* Tags and Labels */}
                  <div 
                    className="absolute"
                    style={{
                      left: 'clamp(55px, 5.73vw, 110px)',
                      top: 'clamp(42px, 4.38vw, 84px)',
                      display: 'flex',
                      gap: 'clamp(6px, 0.63vw, 12px)',
                      flexWrap: 'wrap'
                    }}
                  >
                    <div 
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        height: 'clamp(11px, 1.15vw, 23px)',
                        border: 'clamp(0.5px, 0.05vw, 1px) solid #8f0a0a',
                        borderRadius: 'clamp(0.5px, 0.05vw, 1px)',
                        overflow: 'hidden'
                      }}
                    >
                      <div 
                        style={{
                          backgroundColor: 'rgba(143, 10, 10, 0.4)',
                          height: '100%',
                          padding: '0 clamp(5px, 0.57vw, 11px)',
                          display: 'flex',
                          alignItems: 'center',
                          fontFamily: 'Keania One',
                          fontSize: 'clamp(6px, 0.63vw, 12px)',
                          color: 'rgba(255, 255, 255, 0.7)'
                        }}
                      >
                        by Bojar
                      </div>
                      <div 
                        style={{
                          backgroundColor: '#8f0a0a',
                          height: '100%',
                          padding: '0 clamp(3px, 0.36vw, 7px)',
                          display: 'flex',
                          alignItems: 'center',
                          fontFamily: 'Keania One',
                          fontSize: 'clamp(6px, 0.63vw, 12px)',
                          color: 'rgba(255, 255, 255, 0.7)'
                        }}
                      >
                        5
                      </div>
                    </div>
                    <div 
                      style={{
                        backgroundColor: 'rgba(143, 10, 10, 0.4)',
                        border: 'clamp(0.5px, 0.05vw, 1px) solid #8f0a0a',
                        height: 'clamp(11px, 1.15vw, 23px)',
                        padding: '0 clamp(5px, 0.57vw, 11px)',
                        display: 'flex',
                        alignItems: 'center',
                        fontFamily: 'Keania One',
                        fontSize: 'clamp(6px, 0.63vw, 12px)',
                        color: 'rgba(255, 255, 255, 0.7)'
                      }}
                    >
                      01.2026
                    </div>
                    <div 
                      style={{
                        backgroundColor: 'rgba(143, 10, 10, 0.4)',
                        border: 'clamp(0.5px, 0.05vw, 1px) solid #8f0a0a',
                        height: 'clamp(11px, 1.15vw, 23px)',
                        padding: '0 clamp(6px, 0.68vw, 13px)',
                        display: 'flex',
                        alignItems: 'center',
                        fontFamily: 'Keania One',
                        fontSize: 'clamp(6px, 0.63vw, 12px)',
                        color: 'rgba(255, 255, 255, 0.7)'
                      }}
                    >
                      Pixel Art
                    </div>
                    <div 
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        height: 'clamp(11px, 1.15vw, 23px)',
                        border: 'clamp(0.5px, 0.05vw, 1px) solid #8f0a0a',
                        borderRadius: 'clamp(0.5px, 0.05vw, 1px)',
                        overflow: 'hidden'
                      }}
                    >
                      <div 
                        style={{
                          backgroundColor: 'rgba(143, 10, 10, 0.4)',
                          height: '100%',
                          padding: '0 clamp(3px, 0.31vw, 6px)',
                          display: 'flex',
                          alignItems: 'center',
                          fontFamily: 'Keania One',
                          fontSize: 'clamp(6px, 0.63vw, 12px)',
                          color: 'rgba(255, 255, 255, 0.7)'
                        }}
                      >
                        Bestseller
                      </div>
                      <div 
                        style={{
                          backgroundColor: '#8f0a0a',
                          height: '100%',
                          padding: '0 clamp(3px, 0.36vw, 7px)',
                          display: 'flex',
                          alignItems: 'center',
                          fontFamily: 'Keania One',
                          fontSize: 'clamp(6px, 0.63vw, 12px)',
                          color: 'rgba(255, 255, 255, 0.7)'
                        }}
                      >
                        4
                      </div>
                    </div>
                  </div>
                </div>

                {/* Stats Section - Right Side */}
                <div 
                  className="absolute"
                  style={{
                    right: 'clamp(10px, 1.04vw, 20px)',
                    top: 'clamp(29px, 3.02vw, 58px)',
                    display: 'flex',
                    gap: 'clamp(30px, 3.13vw, 60px)'
                  }}
                >
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div 
                      style={{
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(6px, 0.63vw, 12px)',
                        color: 'rgba(255, 255, 255, 0.8)',
                        marginBottom: 'clamp(2px, 0.21vw, 4px)',
                        textAlign: 'center',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      Amount
                    </div>
                    <div 
                      style={{
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(8px, 0.83vw, 16px)',
                        color: '#FFFFFF',
                        textAlign: 'center'
                      }}
                    >
                      {collectionData?.stats?.amount ?? 0}
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div 
                      style={{
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(6px, 0.63vw, 12px)',
                        color: 'rgba(255, 255, 255, 0.8)',
                        marginBottom: 'clamp(2px, 0.21vw, 4px)',
                        textAlign: 'center',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      Listed
                    </div>
                    <div 
                      style={{
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(8px, 0.83vw, 16px)',
                        color: '#FFFFFF',
                        textAlign: 'center'
                      }}
                    >
                      {collectionData?.stats?.listed ?? 0}
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div 
                      style={{
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(6px, 0.63vw, 12px)',
                        color: 'rgba(255, 255, 255, 0.8)',
                        marginBottom: 'clamp(2px, 0.21vw, 4px)',
                        textAlign: 'center',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      Floor Price
                    </div>
                    <div 
                      style={{
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(8px, 0.83vw, 16px)',
                        color: '#FFFFFF',
                        textAlign: 'center'
                      }}
                    >
                      {collectionData?.stats?.floorPrice === null || collectionData?.stats?.floorPrice === undefined ? '--' : collectionData.stats.floorPrice}
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div 
                      style={{
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(6px, 0.63vw, 12px)',
                        color: 'rgba(255, 255, 255, 0.8)',
                        marginBottom: 'clamp(2px, 0.21vw, 4px)',
                        textAlign: 'center',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      Followers
                    </div>
                    <div 
                      style={{
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(8px, 0.83vw, 16px)',
                        color: '#FFFFFF',
                        textAlign: 'center'
                      }}
                    >
                      {collectionData?.stats?.followers ?? 0}
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div 
                      style={{
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(6px, 0.63vw, 12px)',
                        color: 'rgba(255, 255, 255, 0.8)',
                        marginBottom: 'clamp(2px, 0.21vw, 4px)',
                        textAlign: 'center',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      Faworites
                    </div>
                    <div 
                      style={{
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(8px, 0.83vw, 16px)',
                        color: '#FFFFFF',
                        textAlign: 'center'
                      }}
                    >
                      {collectionData?.stats?.favorites ?? 0}
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div 
                      style={{
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(6px, 0.63vw, 12px)',
                        color: 'rgba(255, 255, 255, 0.8)',
                        marginBottom: 'clamp(2px, 0.21vw, 4px)',
                        textAlign: 'center',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      Volume
                    </div>
                    <div 
                      style={{
                        fontFamily: 'Keania One',
                        fontWeight: 400,
                        fontSize: 'clamp(8px, 0.83vw, 16px)',
                        color: '#FFFFFF',
                        textAlign: 'center'
                      }}
                    >
                      {collectionData?.stats?.volume === null || collectionData?.stats?.volume === undefined ? '--' : collectionData.stats.volume}
                    </div>
                  </div>
                </div>
              </div>

              {/* NFT Cards Grid */}
              <div 
                className="absolute"
                style={{
                  left: 'clamp(12px, 1.25vw, 24px)',
                  top: 'clamp(282px, 29.38vw, 565px)',
                  width: 'calc(100% - clamp(24px, 2.5vw, 48px))',
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 'clamp(11px, 1.15vw, 22px)'
                }}
              >
                {nftImages.map((image, index) => {
                  const isLiked = isNFTLiked(index);
                  
                  return (
                  <div 
                    key={index} 
                    className="relative"
                    style={{
                      width: 'clamp(120px, 12.5vw, 240px)',
                      flexShrink: 0
                    }}
                    onMouseEnter={() => setHoveredCardIndex(index)}
                    onMouseLeave={() => setHoveredCardIndex(null)}
                  >
                    {/* Like Button - Left Top Corner */}
                    <div
                      onClick={(e) => handleLikeToggle(e, index)}
                      className="absolute z-20 flex items-center justify-center hover:opacity-90 transition-opacity cursor-pointer"
                      style={{
                        left: '0',
                        top: '0',
                        width: 'clamp(27.5px, 2.86vw, 55px)',
                        height: 'clamp(20px, 2.08vw, 40px)',
                        backgroundColor: 'rgba(20, 20, 20, 0.6)',
                        borderTopLeftRadius: 'clamp(2px, 0.21vw, 4px)',
                        borderTopRightRadius: 'clamp(2px, 0.21vw, 4px)',
                        borderBottomRightRadius: 'clamp(2px, 0.21vw, 4px)'
                      }}
                    >
                      <img
                        src={isLiked ? likeIcon : unLikeIconImage}
                        alt={isLiked ? 'Remove from favorites' : 'Add to favorites'}
                        style={{
                          width: 'clamp(15px, 1.56vw, 30px)',
                          height: 'clamp(15px, 1.56vw, 30px)',
                          transform: animatingLikeIndex === index ? 'scale(1.5)' : 'scale(1)',
                          transition: 'transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)'
                        }}
                      />
                    </div>
                    
                    {/* NFT Image */}
                    <div 
                      style={{
                        width: 'clamp(120px, 12.5vw, 240px)',
                        height: 'clamp(120px, 12.5vw, 240px)',
                        borderTopLeftRadius: 'clamp(2px, 0.21vw, 4px)',
                        borderTopRightRadius: 'clamp(2px, 0.21vw, 4px)',
                        overflow: 'hidden',
                        backgroundColor: '#000000'
                      }}
                    >
                      <img 
                        src={image}
                        alt={`NFT ${index + 1}`}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover'
                        }}
                      />
                    </div>
                    {/* NFT Info Footer */}
                    <div 
                      style={{
                        width: 'clamp(120px, 12.5vw, 240px)',
                        height: 'clamp(25px, 2.6vw, 50px)',
                        backgroundColor: '#000000',
                        borderBottomLeftRadius: 'clamp(2px, 0.21vw, 4px)',
                        borderBottomRightRadius: 'clamp(2px, 0.21vw, 4px)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '0 clamp(6px, 0.68vw, 13px)'
                      }}
                    >
                      <div 
                        style={{
                          fontFamily: 'Keania One',
                          fontWeight: 400,
                          fontSize: 'clamp(7px, 0.73vw, 14px)',
                          color: 'rgba(255, 255, 255, 0.8)',
                          flex: 1,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap'
                        }}
                      >
                        {collectionData?.nfts?.[index]?.nftname || `NFT ${index + 1}`}
                      </div>
                      {hoveredCardIndex === index ? (
                        <div 
                          style={{
                            fontFamily: 'Keania One',
                            fontWeight: 400,
                            fontSize: 'clamp(6px, 0.63vw, 12px)',
                            color: 'rgba(255, 255, 255, 0.8)'
                          }}
                        >
                          Buy
                        </div>
                      ) : (
                        <div 
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 'clamp(2px, 0.21vw, 4px)',
                            backgroundColor: 'rgba(84, 146, 232, 0.18)',
                            border: 'clamp(0.5px, 0.05vw, 1px) solid #5492e8',
                            height: 'clamp(10px, 1.04vw, 20px)',
                            padding: '0 clamp(3px, 0.31vw, 6px)',
                            borderRadius: 'clamp(0.5px, 0.05vw, 1px)',
                            flexShrink: 0
                          }}
                        >
                          <img 
                            src={coins_1}
                            alt="Coin"
                            style={{
                              width: 'clamp(6px, 0.63vw, 12px)',
                              height: 'clamp(6px, 0.63vw, 12px)',
                              opacity: 0.8
                            }}
                          />
                          <div 
                            style={{
                              fontFamily: 'Keania One',
                              fontWeight: 400,
                              fontSize: 'clamp(6px, 0.63vw, 12px)',
                              color: 'rgba(255, 255, 255, 0.8)'
                            }}
                          >
                            0.84
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Buy Button - appears over footer on hover */}
                    {hoveredCardIndex === index && (
                      <div 
                        className="absolute"
                        style={{
                          left: '0px',
                          top: 'clamp(120px, 12.5vw, 240px)',
                          width: 'clamp(120px, 12.5vw, 240px)',
                          height: 'clamp(25px, 2.6vw, 50px)',
                          backgroundColor: '#5492e8',
                          borderBottomLeftRadius: 'clamp(2px, 0.21vw, 4px)',
                          borderBottomRightRadius: 'clamp(2px, 0.21vw, 4px)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          transition: 'opacity 0.2s',
                          zIndex: 10
                        }}
                        onClick={() => navigate(`/collection/${slug}/purchase?nft=${index}`)}
                        onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
                        onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
                      >
                        <div 
                          style={{
                            fontFamily: 'Keania One',
                            fontWeight: 400,
                            fontSize: 'clamp(9px, 0.94vw, 18px)',
                            color: '#FFFFFF'
                          }}
                        >
                          Buy
                        </div>
                      </div>
                    )}
                  </div>
                  );
                })}
              </div>
            </div>
          </div>
          <Footer />
        </main>
      </div>
      <AuthModal 
        isOpen={isAuthModalOpen} 
        onClose={() => setIsAuthModalOpen(false)} 
      />
    </div>
  );
}
